<template>
    <div class="dropdown-filter" v-if="filter.items">
        <cmp-form-field-select v-if="hasFilterItems"
                v-bind="bindData(filter)"
                @input="updateFilterValue($event)">
        </cmp-form-field-select>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';


    export default {
        computed: {
            ...mapGetters(['filter']),
            hasFilterItems() {
                return Array.isArray(this.filter.items) && this.filter.items.length > 0;
            },
            filterQuery() {
                return this.filter.filterQuery;
            },
            queryParams() {
                return this.$route.query || {};
            },
        },
        methods: {
            ...mapActions(['setFilterValue']),
            updateFilterValue(val) {
                this.setFilterValue({ val });
            },
            updateFilterQuery(val) {
                if (!this.filterQuery) {
                    return;
                }

                this.$router.replace({
                    query: Object.assign(
                        {},
                        this.$route.query,
                        { [this.filterQuery]: val }
                    ),
                });
            },
            bindData({ items, val: value, placeholder }) {
                return { items, value, placeholder };
            },
        },
        watch: {
            'filter.filterQuery': {
                handler() {
                    this.updateFilterValue(this.queryParams[this.filterQuery] || 'all');
                },
            },
            'filter.val': {
                handler(val) {
                    this.updateFilterQuery(val);
                },
            },
            '$route.query': {
                handler() {
                    this.updateFilterValue(this.queryParams[this.filterQuery] || 'all');
                },
                immediate: true,
            },
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?82f17f0a